export enum FlowTabs {
  actions = 'actions',
  flows = 'flows',
}
